const START_SCREEN = 'terminal.start';
const GUIDE_SCREEN = 'terminal.guide';
const DESKTOP_START = 'web.start';
const DESKTOP_SEARCH = 'web.search';
const TERMINAL_START = 'terminal.start';
const SEARCH_SCREEN = 'terminal.search';
const TERMINAL_MOVIES = 'terminal.movies';
const TERMINAL_VIDEOSHOP = 'terminal.videoshop';
const TERMINAL_MOVIE_DETAILS = 'terminal.movie.details';
const TERMINAL_STANDARD_GUIDE = 'terminal.standard.guide';

const MOBILE_ROOT = 'mobile.root';
const MOBILE_MENU = 'mobile.menu';
const MOBILE_HOME = 'mobile.home';
const MOBILE_GUIDE = 'mobile.guide';
const MOBILE_CARE = 'mobile.care';
const MOBILE_CATEGORY = 'mobile.category';
const MOBILE_SERVICES = 'mobile.services';
const MOBILE_SERVICE = 'mobile.service';
const MOBILE_SEARCH = 'mobile.search';
const MOBILE_SEARCHBAR = 'mobile.searchbar';

const WEB_START = 'web.start';
const WEB_GUIDE = 'web.guide';
const WEB_SERVICE = 'web.service';
const DESKTOP_START_SCREEN = 'web.start';

const VIEWS = {
    MAIN: 'main',
    SERVICES: 'services',
    SHOPPING: 'shopping',
    HEALTH_BEING: 'healthBeing',
    FOOD_DRINK: 'foodDrink',
    GUIDE: 'guide',
    SEARCHBAR: 'searchbar',
    BRANDS: 'brands',
    VIDEO_SHOP: 'videoShop',
    MOVIE_DETAILS: 'movieDetails',
    TRANSPORT: 'transport'
};

const TYPES = {
    CARE: 'care'
};

export {
    VIEWS,
    TYPES,
    WEB_GUIDE,
    WEB_START,
    MOBILE_MENU,
    MOBILE_HOME,
    MOBILE_ROOT,
    MOBILE_CARE,
    WEB_SERVICE,
    GUIDE_SCREEN,
    START_SCREEN,
    MOBILE_GUIDE,
    SEARCH_SCREEN,
    MOBILE_SERVICE,
    TERMINAL_START,
    MOBILE_CATEGORY,
    TERMINAL_MOVIES,
    MOBILE_SERVICES,
    MOBILE_SEARCH,
    DESKTOP_START,
    DESKTOP_SEARCH,
    MOBILE_SEARCHBAR,
    TERMINAL_VIDEOSHOP,
    DESKTOP_START_SCREEN,
    TERMINAL_MOVIE_DETAILS,
    TERMINAL_STANDARD_GUIDE
};
